import { render, staticRenderFns } from "./HolidayDialog.vue?vue&type=template&id=3ed8f085&scoped=true"
import script from "./HolidayDialog.vue?vue&type=script&lang=ts"
export * from "./HolidayDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8f085",
  null
  
)

export default component.exports